import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable camelcase */
const Contact = ({
  email,
  name,
  phone_number = null,
}) => {
  return (
    <>
      <div className="content__contact">
        <div className="content__contact__name">{name}</div>
        <div className="content__contact__email"><a href={`mailto:${email}`}>{email}</a></div>
        <div className="content__contact__phone">{phone_number}</div>
      </div>
    </>
  );
};

Contact.propTypes = {
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  phone_number: PropTypes.string,
};

export default Contact;
